export class CustomerLegalForm
{
    id:number;
    active:boolean;
    label:String;
}